import screenVariables from '@dealroadshow/uikit-styles/variables/screen.module';
import { IAiSidebarState } from '@/creditflowresearch/domain/vo/AiSidebar';

export const SIDEBAR_MIN_WIDTH = 500;
export const SIDEBAR_MAX_WIDTH = 650;

export const SIDEBAR_WIDTH_STEP = 16;

const getMinCfrWidth = (): number => parseInt(screenVariables.screenS);

export const getMinViewportForSidebar = (width: number): number => getMinCfrWidth() + width;

export const getSplitMinViewport = (): number => getMinViewportForSidebar(SIDEBAR_MIN_WIDTH);

export const limitSidebarWidth = (width: number): number => {
  return Math.min(Math.max(width, SIDEBAR_MIN_WIDTH), SIDEBAR_MAX_WIDTH);
};

export const clampSidebarWidth = (width: number, viewportWidth: number): number => {
  const max = Math.max(Math.min(SIDEBAR_MAX_WIDTH, viewportWidth - getMinCfrWidth()), SIDEBAR_MIN_WIDTH);

  return Math.min(Math.max(width, SIDEBAR_MIN_WIDTH), max);
};

export const AI_SIDEBAR_COOKIE_NAME = 'aiSidebar';

export const INITIAL_AI_SIDEBAR_STATE: IAiSidebarState = {
  isOpen: false,
  width: null,
};
